export const LIMITATION_TYPES = {
  NUMERIC_123: "NUMERIC_123",
  ALPHANUMERIC: "ALPHANUMERIC",
  ONLY_NUMBERS: "ONLY_NUMBERS",
};

export const LIMITATIONS = {
  [LIMITATION_TYPES.NUMERIC_123]: { allowedChars: "123", maxLength: 3 },
  [LIMITATION_TYPES.ALPHANUMERIC]: {
    allowedChars:
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
    maxLength: 5,
  },
  [LIMITATION_TYPES.ONLY_NUMBERS]: {
    allowedChars: "0123456789",
    maxLength: 9,
  },
};

export const isCleanValue = (inputValue, limitationType) => {
  const { allowedChars, maxLength } =
    LIMITATIONS[limitationType] || LIMITATIONS.ALPHANUMERIC;

  const regex = new RegExp(`^[${allowedChars}]{0,${maxLength}}$`);
  if (!regex.test(inputValue)) {
    return false;
  }

  return true;
};
